import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="global-footer">
      <div className="footer-nav">
        <div className="footer-copyright">
          <p>© 2025 Glistar AI™. All rights reserved.</p>
        </div>
        <div className="footer-links">
          <a href="/cookie-notice" className="footer-link">Cookie Notice</a>
          <a href="/terms" className="footer-link">Terms</a>
          <a href="/privacy" className="footer-link">Privacy</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
